module.exports = __webpack_public_path__ + "img/building-shield-solid.832e0a29.svg";